const ssn = {
    ssn : {
        value: "",
        dbqName: "form1[0].#subform[0].SSN[0]"
     },
     examDate: {
        value: "",
        dbqName: "form1[0].#subform[0].TextField6[11]"
    },
     docName: {
         value: "",
         dbqName: "form1[0].#subform[13].SectionXIV-ExaminersCertSign[0].TextField8[1]"
     },
     docArea: {
        value: "",
        dbqName: "form1[0].#subform[13].SectionXIV-ExaminersCertSign[0].TextField8[6]"
    },
     docDate: {
        value : "",
        dbqName: "form1[0].#subform[13].SectionXIV-ExaminersCertSign[0].TextField8[7]"
    },
     docNpi: {
         value : "",
         dbqName: "form1[0].#subform[13].SectionXIV-ExaminersCertSign[0].TextField8[3]"
     },
     docPhone: {
        value : "",
        dbqName: "form1[0].#subform[13].SectionXIV-ExaminersCertSign[0].TextField8[2]"
    },
    docLicenseNo: {
        value : "",
        dbqName: "form1[0].#subform[13].SectionXIV-ExaminersCertSign[0].TextField8[4]"
    },
    docAddress: {
        value : "",
        dbqName: "form1[0].#subform[13].SectionXIV-ExaminersCertSign[0].TextField8[5]"
    },
    diagnosisDate : [
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[0].#area[0].CheckBox36[0]",
            sides: {
                right: "form1[0].#subform[0].#area[0].CheckBox36[1]",
                left: "form1[0].#subform[0].#area[0].CheckBox36[2]",
                both: "form1[0].#subform[0].#area[0].CheckBox36[3]",
                rightDateDbqName: "form1[0].#subform[0].#area[0].TextField6[0]",
                leftDateDbqName: "form1[0].#subform[0].#area[0].TextField6[1]"
            },
        },
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[0].#area[1].CheckBox36[4]",
            sides: {
                right: "form1[0].#subform[0].#area[1].CheckBox36[5]",
                left: "form1[0].#subform[0].#area[1].CheckBox36[6]",
                both: "form1[0].#subform[0].#area[1].CheckBox36[7]",
                rightDateDbqName: "form1[0].#subform[0].#area[1].TextField6[2]",
                leftDateDbqName: "form1[0].#subform[0].#area[1].TextField6[3]"
            },
        },
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[0].#area[4].CheckBox36[16]",
            sides: {
                right: "form1[0].#subform[0].#area[4].CheckBox36[17]",
                left: "form1[0].#subform[0].#area[4].CheckBox36[18]",
                both: "form1[0].#subform[0].#area[4].CheckBox36[19]",
                rightDateDbqName: "form1[0].#subform[0].#area[4].TextField6[8]",
                leftDateDbqName: "form1[0].#subform[0].#area[4].TextField6[9]"
            },
        },
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[0].#area[2].CheckBox36[8]",
            sides: {
                right: "form1[0].#subform[0].#area[2].CheckBox36[9]",
                left: "form1[0].#subform[0].#area[2].CheckBox36[10]",
                both: "form1[0].#subform[0].#area[2].CheckBox36[11]",
                rightDateDbqName: "form1[0].#subform[0].#area[2].TextField6[4]",
                leftDateDbqName: "form1[0].#subform[0].#area[2].TextField6[5]"
            },
        },
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[0].#area[3].CheckBox36[12]",
            sides: {
                right: "form1[0].#subform[0].#area[3].CheckBox36[13]",
                left: "form1[0].#subform[0].#area[3].CheckBox36[14]",
                both: "form1[0].#subform[0].#area[3].CheckBox36[15]",
                rightDateDbqName: "form1[0].#subform[0].#area[3].TextField6[6]",
                leftDateDbqName: "form1[0].#subform[0].#area[3].TextField6[7]"
            },
        },
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[4].#area[26].CheckBox36[105]",
            sides: {
                right: "form1[0].#subform[4].#area[26].CheckBox36[106]",
                left: "form1[0].#subform[4].#area[26].CheckBox36[107]",
                both: "form1[0].#subform[4].#area[26].CheckBox36[108]",
                rightDateDbqName: "form1[0].#subform[4].#area[26].TextField6[56]",
                leftDateDbqName: "form1[0].#subform[4].#area[26].TextField6[57]"
            },
        },
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[4].#area[5].CheckBox36[21]",
            sides: {
                right: "form1[0].#subform[4].#area[5].CheckBox36[22]",
                left: "form1[0].#subform[4].#area[5].CheckBox36[23]",
                both: "form1[0].#subform[4].#area[5].CheckBox36[24]",
                rightDateDbqName: "form1[0].#subform[4].#area[5].TextField6[12]",
                leftDateDbqName: "form1[0].#subform[4].#area[5].TextField6[13]"
            },
        },
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[4].#area[6].CheckBox36[25]",
            sides: {
                right: "form1[0].#subform[4].#area[6].CheckBox36[26]",
                left: "form1[0].#subform[4].#area[6].CheckBox36[27]",
                both: "form1[0].#subform[4].#area[6].CheckBox36[28]",
                rightDateDbqName: "form1[0].#subform[4].#area[6].TextField6[14]",
                leftDateDbqName: "form1[0].#subform[4].#area[6].TextField6[15]"
            },
        },
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[4].#area[7].CheckBox36[29]",
            sides: {
                right: "form1[0].#subform[4].#area[7].CheckBox36[30]",
                left: "form1[0].#subform[4].#area[7].CheckBox36[31]",
                both: "form1[0].#subform[4].#area[7].CheckBox36[32]",
                rightDateDbqName: "form1[0].#subform[4].#area[7].TextField6[16]",
                leftDateDbqName: "form1[0].#subform[4].#area[7].TextField6[17]"
            },
        },
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[4].#area[11].CheckBox36[45]",
            sides: {
                right: "form1[0].#subform[4].#area[11].CheckBox36[46]",
                left: "form1[0].#subform[4].#area[11].CheckBox36[47]",
                both: "form1[0].#subform[4].#area[11].CheckBox36[48]",
                rightDateDbqName: "form1[0].#subform[4].#area[11].TextField6[24]",
                leftDateDbqName: "form1[0].#subform[4].#area[11].TextField6[25]"
            },
        },
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[4].#area[12].CheckBox36[49]",
            sides: {
                right: "form1[0].#subform[4].#area[12].CheckBox36[50]",
                left: "form1[0].#subform[4].#area[12].CheckBox36[51]",
                both: "form1[0].#subform[4].#area[12].CheckBox36[52]",
                rightDateDbqName: "form1[0].#subform[4].#area[12].TextField6[26]",
                leftDateDbqName: "form1[0].#subform[4].#area[12].TextField6[27]"
            },
        },
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[4].#area[13].CheckBox36[53]",
            sides: {
                right: "form1[0].#subform[4].#area[13].CheckBox36[54]",
                left: "form1[0].#subform[4].#area[13].CheckBox36[55]",
                both: "form1[0].#subform[4].#area[13].CheckBox36[56]",
                rightDateDbqName: "form1[0].#subform[4].#area[13].TextField6[28]",
                leftDateDbqName: "form1[0].#subform[4].#area[13].TextField6[29]"
            },
        },
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[4].#area[14].CheckBox36[57]",
            sides: {
                right: "form1[0].#subform[4].#area[14].CheckBox36[58]",
                left: "form1[0].#subform[4].#area[14].CheckBox36[59]",
                both: "form1[0].#subform[4].#area[14].CheckBox36[60]",
                rightDateDbqName: "form1[0].#subform[4].#area[14].TextField6[30]",
                leftDateDbqName: "form1[0].#subform[4].#area[14].TextField6[31]"
            },
        },        
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[4].#area[15].CheckBox36[61]",
            sides: {
                right: "form1[0].#subform[4].#area[15].CheckBox36[62]",
                left: "form1[0].#subform[4].#area[15].CheckBox36[63]",
                both: "form1[0].#subform[4].#area[15].CheckBox36[64]",
                rightDateDbqName: "form1[0].#subform[4].#area[15].TextField6[32]",
                leftDateDbqName: "form1[0].#subform[4].#area[15].TextField6[33]"
            },
        },        
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[4].#area[16].CheckBox36[65]",
            sides: {
                right: "form1[0].#subform[4].#area[16].CheckBox36[66]",
                left: "form1[0].#subform[4].#area[16].CheckBox36[67]",
                both: "form1[0].#subform[4].#area[16].CheckBox36[68]",
                rightDateDbqName: "form1[0].#subform[4].#area[16].TextField6[34]",
                leftDateDbqName: "form1[0].#subform[4].#area[16].TextField6[35]"
            },
        },        
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[4].#area[17].CheckBox36[69]",
            sides: {
                right: "form1[0].#subform[4].#area[17].CheckBox36[70]",
                left: "form1[0].#subform[4].#area[17].CheckBox36[71]",
                both: "form1[0].#subform[4].#area[17].CheckBox36[72]",
                rightDateDbqName: "form1[0].#subform[4].#area[17].TextField6[36]",
                leftDateDbqName: "form1[0].#subform[4].#area[17].TextField6[37]"
            },
        },        
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[4].#area[18].CheckBox36[73]",
            sides: {
                right: "form1[0].#subform[4].#area[18].CheckBox36[74]",
                left: "form1[0].#subform[4].#area[18].CheckBox36[75]",
                both: "form1[0].#subform[4].#area[18].CheckBox36[76]",
                rightDateDbqName: "form1[0].#subform[4].#area[18].TextField6[38]",
                leftDateDbqName: "form1[0].#subform[4].#area[18].TextField6[39]"
            },
        },        
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[4].#area[19].CheckBox36[77]",
            sides: {
                right: "form1[0].#subform[4].#area[19].CheckBox36[78]",
                left: "form1[0].#subform[4].#area[19].CheckBox36[79]",
                both: "form1[0].#subform[4].#area[19].CheckBox36[80]",
                rightDateDbqName: "form1[0].#subform[4].#area[19].TextField6[40]",
                leftDateDbqName: "form1[0].#subform[4].#area[19].TextField6[41]"
            },
        },        
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[4].#area[8].CheckBox36[33]",
            sides: {
                right: "form1[0].#subform[4].#area[8].CheckBox36[34]",
                left: "form1[0].#subform[4].#area[8].CheckBox36[35]",
                both: "form1[0].#subform[4].#area[8].CheckBox36[36]",
                rightDateDbqName: "form1[0].#subform[4].#area[8].TextField6[18]",
                leftDateDbqName: "form1[0].#subform[4].#area[8].TextField6[19]"
            },
        },        
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[4].#area[9].CheckBox36[37]",
            sides: {
                right: "form1[0].#subform[4].#area[9].CheckBox36[38]",
                left: "form1[0].#subform[4].#area[9].CheckBox36[39]",
                both: "form1[0].#subform[4].#area[9].CheckBox36[40]",
                rightDateDbqName: "form1[0].#subform[4].#area[9].TextField6[20]",
                leftDateDbqName: "form1[0].#subform[4].#area[9].TextField6[21]"
            },
        },        
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[4].#area[10].CheckBox36[41]",
            sides: {
                right: "form1[0].#subform[4].#area[10].CheckBox36[42]",
                left: "form1[0].#subform[4].#area[10].CheckBox36[43]",
                both: "form1[0].#subform[4].#area[10].CheckBox36[44]",
                rightDateDbqName: "form1[0].#subform[4].#area[10].TextField6[22]",
                leftDateDbqName: "form1[0].#subform[4].#area[10].TextField6[23]"
            },
        },        
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[4].#area[20].CheckBox36[81]",
            sides: {
                right: "form1[0].#subform[4].#area[20].CheckBox36[82]",
                left: "form1[0].#subform[4].#area[20].CheckBox36[83]",
                both: "form1[0].#subform[4].#area[20].CheckBox36[84]",
                rightDateDbqName: "form1[0].#subform[4].#area[20].TextField6[43]",
                leftDateDbqName: "form1[0].#subform[4].#area[20].TextField6[44]"
            },
        },        
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[4].#area[21].CheckBox36[85]",
            sides: {
                right: "form1[0].#subform[4].#area[21].CheckBox36[86]",
                left: "form1[0].#subform[4].#area[21].CheckBox36[87]",
                both: "form1[0].#subform[4].#area[21].CheckBox36[88]",
                rightDateDbqName: "form1[0].#subform[4].#area[21].TextField6[45]",
                leftDateDbqName: "form1[0].#subform[4].#area[21].TextField6[46]"
            },
        },        
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[4].#area[22].CheckBox36[89]",
            sides: {
                right: "form1[0].#subform[4].#area[22].CheckBox36[90]",
                left: "form1[0].#subform[4].#area[22].CheckBox36[91]",
                both: "form1[0].#subform[4].#area[22].CheckBox36[92]",
                rightDateDbqName: "form1[0].#subform[4].#area[22].TextField6[47]",
                leftDateDbqName: "form1[0].#subform[4].#area[22].TextField6[48]"
            },
        },        
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[4].#area[23].CheckBox36[93]",
            sides: {
                right: "form1[0].#subform[4].#area[23].CheckBox36[94]",
                left: "form1[0].#subform[4].#area[23].CheckBox36[95]",
                both: "form1[0].#subform[4].#area[23].CheckBox36[96]",
                rightDateDbqName: "form1[0].#subform[4].#area[23].TextField6[49]",
                leftDateDbqName: "form1[0].#subform[4].#area[23].TextField6[50]"
            },
        },        
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[4].#area[24].CheckBox36[97]",
            sides: {
                right: "form1[0].#subform[4].#area[24].CheckBox36[98]",
                left: "form1[0].#subform[4].#area[24].CheckBox36[99]",
                both: "form1[0].#subform[4].#area[24].CheckBox36[100]",
                rightDateDbqName: "form1[0].#subform[4].#area[24].TextField6[51]",
                leftDateDbqName: "form1[0].#subform[4].#area[24].TextField6[52]"
            },
        },        
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[4].CheckBox36[124]",
            sides: {
                right: "form1[0].#subform[4].#area[28].CheckBox36[110]",
                left: "form1[0].#subform[4].#area[28].CheckBox36[111]",
                both: "form1[0].#subform[4].#area[28].CheckBox36[112]",
                rightDateDbqName: "form1[0].#subform[4].#area[28].TextField6[60]",
                leftDateDbqName: "form1[0].#subform[4].#area[28].TextField6[61]"
            },
        },        
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[4].#area[31].CheckBox36[120]",
            sides: {
                right: "form1[0].#subform[4].#area[31].CheckBox36[121]",
                left: "form1[0].#subform[4].#area[31].CheckBox36[122]",
                both: "form1[0].#subform[4].#area[31].CheckBox36[123]",
                rightDateDbqName: "form1[0].#subform[4].#area[31].TextField6[66]",
                leftDateDbqName: "form1[0].#subform[4].#area[31].TextField6[67]"
            },
        },        
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[4].#area[30].CheckBox36[116]",
            sides: {
                right: "form1[0].#subform[4].#area[30].CheckBox36[117]",
                left: "form1[0].#subform[4].#area[30].CheckBox36[118]",
                both: "form1[0].#subform[4].#area[30].CheckBox36[119]",
                rightDateDbqName: "form1[0].#subform[4].#area[30].TextField6[64]",
                leftDateDbqName: "form1[0].#subform[4].#area[30].TextField6[65]"
            },
        },        
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[4].#area[28].CheckBox36[109]",
            sides: {
                right: "form1[0].#subform[4].#area[29].CheckBox36[113]",
                left: "form1[0].#subform[4].#area[29].CheckBox36[114]",
                both: "form1[0].#subform[4].#area[29].CheckBox36[115]",
                rightDateDbqName: "form1[0].#subform[4].#area[29].TextField6[62]",
                leftDateDbqName: "form1[0].#subform[4].#area[29].TextField6[63]"
            },
        },        
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[4].#area[25].CheckBox36[101]",
            sides: {
                right: "form1[0].#subform[4].#area[25].CheckBox36[102]",
                left: "form1[0].#subform[4].#area[25].CheckBox36[103]",
                both: "form1[0].#subform[4].#area[25].CheckBox36[104]",
                rightDateDbqName: "form1[0].#subform[4].#area[25].TextField6[53]",
                leftDateDbqName: "form1[0].#subform[4].#area[25].TextField6[54]"
            },
        },
        {
            type: "text",
            dbqName: "form1[0].#subform[4].TextField6[68]",
            sides: {
                right: "form1[0].#subform[4].CheckBox36[126]",
                left: "form1[0].#subform[4].CheckBox36[127]",
                both: "form1[0].#subform[4].CheckBox36[128]",
                rightDateDbqName: "form1[0].#subform[4].TextField6[69]",
                leftDateDbqName: "form1[0].#subform[4].TextField6[70]"
            },
        },
        {
            type: "text",
            dbqName: "form1[0].#subform[4].TextField6[71]",
            sides: {
                right: "form1[0].#subform[4].CheckBox36[129]",
                left: "form1[0].#subform[4].CheckBox36[130]",
                both: "form1[0].#subform[4].CheckBox36[131]",
                rightDateDbqName: "form1[0].#subform[4].TextField6[72]",
                leftDateDbqName: "form1[0].#subform[4].TextField6[73]"
            },
        },
        {
            type: "text",
            dbqName: "form1[0].#subform[4].TextField6[75]",
            sides: {
                right: "form1[0].#subform[4].CheckBox36[132]",
                left: "form1[0].#subform[4].CheckBox36[133]",
                both: "form1[0].#subform[4].CheckBox36[134]",
                rightDateDbqName: "form1[0].#subform[4].TextField6[76]",
                leftDateDbqName: "form1[0].#subform[4].TextField6[77]"
            },
        },  
    ]
}

export default ssn ;